import { IPlatform } from "../interfaces/ow-wrappers/ow-wrapper.interface";

export const kNotificationWindowName = 'notification';
export const kTesterWindowName = 'tester';
export const kDITokenOwTesterWindow = 'ow-tester-window';
export const KTesterWindowName = 'tester';
export const KNameOfLastNotificationInfo = 'last-notification-info';
export const kNameOfDownloadPlugin = 'downloader-plugin';
export const kNameOfSimpleIOPlugin = 'simple-io-plugin';
export const kNameOfDownloadService = 'DownloadService';
export const kNameOfSimplePluginService = 'SimplePluginService';
export const kNameOfRegistryWrapper = 'registryWrapper';
export const kNameOfOwCRNDlUserAgent = 'Overwolf CRN Downloader';

export const kNameOfApprovedDLCertificates = [
  '7E555D99CC1F1A9FAC1205E31D7A2E5CB369D672',
  '17AC7A6D7F20F48993BC7098A88DD051DA90BCFD',
  '4CFB89FAA49539A58968D81960B3C1258E8F6A34',
  '7622C0BC58B09EA199633C6BBBB92A7B0057B2F7',
  '17AC7A6D7F20F48993BC7098A88DD051DA90BCFD',
  'A2AC3B36FB87C6C17A7A01F317500CE926A64254',
  '962A9D59796B8C6AE1A7D8FAE72EC3729A898814',
];

export const kOwRegistryPath = '\\SOFTWARE\\WOW6432Node\\Overwolf';
export const kOwElectronRegistryPath = 'Software\\OverwolfElectron';
export const kOwElectronEnableNotifications = 'enableNotifications';
export const kOwRegistryKey = 'InstallFolder';

export const kPlatformMap = new Map<IPlatform, string>([
  ['ow', 'phasingForOverwolf'],
  ['owe', 'phasingForElectron'],
]);
